import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import type { CustomerPlanDisplayStatus } from '@/types/customer-plan-management';

interface BillingActionRequiredBannerProps {
  status: CustomerPlanDisplayStatus;
  onCompletePayment: () => void;
}

export function BillingActionRequiredBanner({ status, onCompletePayment }: BillingActionRequiredBannerProps) {
  const { t } = useTranslation();

  const titleKey =
    status === 'incomplete' || status === 'incomplete_expired'
      ? 'customer.planManagement.billingIssue.incompleteTitle'
      : 'customer.planManagement.billingIssue.title';

  return (
    <Alert className="border-amber-500/30 bg-amber-50 text-amber-950 dark:bg-amber-500/10 dark:text-amber-50">
      <AlertTriangle className="h-5 w-5 text-amber-700 dark:text-amber-300" />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
          <AlertTitle className="text-amber-950 dark:text-amber-50">{t(titleKey)}</AlertTitle>
          <AlertDescription className="text-amber-900/80 dark:text-amber-50/80">
            {t('customer.planManagement.billingIssue.description')}
          </AlertDescription>
        </div>
        <Button type="button" size="sm" onClick={onCompletePayment} className="w-full shrink-0 sm:w-auto">
          {t('customer.planManagement.billingIssue.cta')}
        </Button>
      </div>
    </Alert>
  );
}

